import { TICKET } from "./action";

const initialState = {
  LoadNumberIndicatorList: [],
  CounterPart: [],
  suggestedOriginType: [],
  searchTerm: "",
  counterPartyTicketData:[],
  counterPartyDashboard:[],
  loader:false,
  ticketDataLoader:false,
  dashboardDataLoader:false,
  groupByValue: "Truckline",
  previousDaysvalue: 7,
  pageData: {},
  previousDaysFarmsvalue:7,
  lastdaylength:2,
};

export function ticketReducer(state = initialState, action) {
  switch (action.type) {
    case TICKET.create.success:
      return Object.assign({}, state, {
        fetchingComplete: true,
        ticketCreated: action.data
      });
    case TICKET.create.error:
      return Object.assign({}, state, {
        fetchingComplete: true,
        ticketCreated: action.data
      });
    case TICKET.edit.success:
      return Object.assign({}, state, {
        TicketUpdated: action.data
      });
    case TICKET.edit.selected:
      return Object.assign({}, state, {
        EditSelectedTicket: action.data
      });
    case TICKET.delete.success:
      const ticketId = action.data.data.id;
      return Object.assign({}, state, {
        TicketList: state.TicketList.filter(
          TicketList => TicketList.id !== ticketId
        )
      });
    case TICKET.getAllCounterpartList.success:
      return Object.assign({}, state, {
        CounterPart: action.data,
        suggestedCounterparts: action.suggestedData
      });
    case TICKET.getOriginType.success:
      return Object.assign({}, state, {
        originTypeInternal: action.data,
        suggestedOriginType: action.suggestedData
      });
    case TICKET.getAllTicketsList.success:
      return Object.assign({}, state, {
        TicketList: action.data,
        ticketCreated: {},
        TicketUpdated: {}
      });
    case TICKET.getTicketsList.start:
      return Object.assign({}, state, {
        fetchingComplete: false,
        TicketList: [],
        ticketCreated: {},
        TicketUpdated: {}
      });
    case TICKET.getTicketsList.success:
      return Object.assign({}, state, {
        fetchingComplete: true,
        TicketList: action.data.data,
        pageCount: action.data.totalPages,
        totalElements: action.data.totalElements,
        ticketCreated: {},
        TicketUpdated: {}
      });
      case TICKET.getCounterPartyTicketsList.start:
        return Object.assign({}, state, {
          loader:true,
        });
        case TICKET.getCounterPartyTicketsList.error:
          return Object.assign({}, state, {
            loader:false,
          });
      case TICKET.getCounterPartyTicketsList.success:
        return Object.assign({}, state, {
          fetchingComplete: true,
          loader:false,
          CounterPartyTicketList: action.data.data,
          ticketCreated: {},
          TicketUpdated: {}
        });
        case TICKET.getCounterPartyTicketsListData.start:
          return Object.assign({}, state, {
            ticketDataLoader:true,
          });
          case TICKET.getCounterPartyTicketsListData.error:
            return Object.assign({}, state, {
              ticketDataLoader:false,
            });
        case TICKET.getCounterPartyTicketsListData.success:
          return Object.assign({}, state, {
            ticketDataLoader:false,
            counterPartyTicketData:  action.data.data.data,
            pageData: action.data.data.pageData,

          });
          case TICKET.getCounterPartyDashboardData.start:
            return Object.assign({}, state, {
              dashboardDataLoader:true,
            });
            case TICKET.getCounterPartyDashboardData.error:
              return Object.assign({}, state, {
                dashboardDataLoader:false,
              });
          case TICKET.getCounterPartyDashboardData.success:
            return Object.assign({}, state, {
              dashboardDataLoader:false,
              counterPartyDashboard:  action.data.data,
              pageData: action.data.pageData,
  
            });
            case TICKET.getCounterPartyDashboardDataByOne.success:
            return Object.assign({}, state, {
              lastdaylength:  action.data.data,  
            });
    case TICKET.loadNumberIndicator.success:
      return Object.assign({}, state, {
        LoadNumberIndicatorList: action.data,
        suggestedLoadNumber: action.suggestedData
      });
    case TICKET.indicatorCodeCount.success:
      return Object.assign({}, state, {
        indicatorCodeCount: action.data
      });
    case TICKET.delete.locked:
      return Object.assign({}, state, {
        ticketCreated: action.data
      });
    case TICKET.setSearchTerm.success:
      return {
        ...state,
        searchTerm: action.data
      };
    case TICKET.setGroupBy.success:
      return {
        ...state,
        groupByValue: action.data,
      }
    case TICKET.setPreviousDays.success:
      return {
        ...state,
        previousDaysvalue: action.data,
      }
      case TICKET.setPreviousFarmsDays.success:
      return {
        ...state,
        previousDaysFarmsvalue: action.data,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/ticket/reducer.js